/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {

        window.onscroll = function() {};

        $(window).scroll(function() {
          NavFixed();
        });

        var admin_bar = $('#wpadminbar');
        var header = $('.primary-menu');
        var sticky = header.offset().top;

        function NavFixed() {
          if ($(window).scrollTop() > sticky) {
            header.addClass("sticky");
            if (admin_bar.length && $(window).outerWidth() > 600) {
              header.find('.primary-menu-wrap').css('margin-top', admin_bar.outerHeight());
            }
          } else {
            header.removeClass("sticky");
            header.find('.primary-menu-wrap').css('margin-top', 'auto');
          }
        }

        $("#menu-menu-primary .menu-item-has-children").each(function() {
          sub_child = $(this).find('.dropdown-menu').children().length;
          if (sub_child > 0) {
            $(this).find('> a').append('<span class="expand ml-2"><i class="icon icon-angle-down "></i></span>');
          }
        });

        $(".navbar-nav-mobile .menu-item-has-children").each(function() {
          sub_child = $(this).find('.dropdown-menu').children().length;
          if (sub_child > 0) {
            $(this).find('> a').append('<span class="expand ml-2"><i class="icon icon-angle-right "></i></span>');
          }
        });

        $('#app-mobile-menu .navbar-nav-mobile li .expand').click(function (e) {
            e.preventDefault();

            $(this).toggleClass('active');
            $(this).find('i').toggleClass('icon-angle-down');
            $(this).parent('a').parent('li').children('.dropdown-menu').slideToggle(100);
        })


        $('body').on('click', function (e) {
            //did not click a popover toggle, or icon in popover toggle, or popover
            if ($(e.target).data('toggle') !== 'popover'
                && $(e.target).parents('[data-toggle="popover"]').length === 0
                && $(e.target).parents('.popover.in').length === 0) {
                $('[data-toggle="popover"]').popover('hide');
            }
        });


          $('.banner-slider').slick({
              dots: true,
              infinite: true,
              speed: 500,
              autoplay: true,
              autoplaySpeed: 1500,
              adaptiveHeight: true,
              pauseOnHover: false,
              arrows: false
          });

        $(".slider-related-wrap .products ").each(function() {
          $(this).slick({
            dots: false,
            infinite: true,
            speed: 500,
            slidesToShow: 3,
            autoplay: false,
            arrows: true,
            nextArrow: $(this).parent('.slider-related-wrap').find('.slide-next'),
            prevArrow: $(this).parent('.slider-related-wrap').find('.slide-prev'),
            responsive: [{
                breakpoint: 576,
                settings: {
                  slidesToShow: 1,
                  adaptiveHeight: true,
                }
              },
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: 2,
                  adaptiveHeight: true,
                }
              },
            ],
          });
        });

        if ( $(".slider-comments-wrap .commentlist" ).length<=0 ) {
          $(".slider-comments-wrap .slick-arrow" ).addClass('slick-hidden');
        }

        $(".slider-comments-wrap .commentlist").each(function() {
          $(".slider-comments-wrap .commentlist").slick({
            dots: false,
            infinite: true,
            speed: 500,
            slidesToShow: 2,
            autoplay: false,
            arrows: true,
            nextArrow: $('.slider-comments-wrap .slide-next'),
            prevArrow: $('.slider-comments-wrap .slide-prev'),
            responsive: [{
                breakpoint: 580,
                settings: {
                  slidesToShow: 1,
                  adaptiveHeight: true,
                }
              },
              {
                breakpoint: 991,
                settings: {
                  slidesToShow: 2,
                  adaptiveHeight: true,
                }
              },
              {
                breakpoint: 1000,
                settings: {
                  slidesToShow: 2,
                }
              },
              {
                breakpoint: 1200,
                settings: {
                  slidesToShow: 2
                }
              },
            ],
          });
        });

        $(".slider-reviews").slick({
          dots: false,
          infinite: true,
          speed: 500,
          slidesToShow: 3,
          autoplay: false,
          arrows: true,
          nextArrow: $('.slider-reviews-wrap .slide-next'),
          prevArrow: $('.slider-reviews-wrap .slide-prev'),
          responsive: [{
              breakpoint: 580,
              settings: {
                slidesToShow: 1,
                adaptiveHeight: true,
              }
            },
            {
              breakpoint: 991,
              settings: {
                slidesToShow: 2,
                adaptiveHeight: true,
              }
            },
            {
              breakpoint: 1000,
              settings: {
                slidesToShow: 3,
              }
            },
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 3
              }
            },
          ],
        });

        $(".slider-category").slick({
          dots: false,
          infinite: true,
          speed: 500,
          slidesToShow: 6,
          autoplay: false,
          arrows: true,
          nextArrow: $('.slider-category-wrap .slide-next'),
          prevArrow: $('.slider-category-wrap .slide-prev'),
          responsive: [{
              breakpoint: 580,
              settings: {
                slidesToShow: 2,
                adaptiveHeight: true,
              }
            },
            {
              breakpoint: 991,
              settings: {
                slidesToShow: 3,
                adaptiveHeight: true,
              }
            },
            {
              breakpoint: 1000,
              settings: {
                slidesToShow: 4,
              }
            },
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 5
              }
            },
          ],
        });

         $(".widget_product_categories .product-categories li, .widget_categories ul li").each(function () {
            sub_child = $(this).find('.children').children().length;
            if (sub_child > 0) {
                $(this).find('> a').append('<span class="expand"><i class="icon icon-plus-circle1"></i></span>');
                $(this).addClass('parent');
            }
        });
        $('.widget_product_categories .product-categories li .expand, .widget_categories ul li .expand').click(function (e) {
            e.preventDefault();
            $('.widget_product_categories .product-categories li.parent, .widget_categories ul li.parent').not($(this).parent('a').parent('li')).removeClass('active');
            $(this).parent('a').parent('li').children('.children').slideToggle(100);
            $('.widget_product_categories .product-categories li .children, .widget_categories ul li .children').not($(this).parent('a').parent('li').children('.children')).slideUp(100);
            $(this).parent('a').parent('li').toggleClass('active');
        });


        $('input[type="checkbox"], input[type="radio"]').each(function () {
          $(this).parent('label').addClass('checkbox-custom');
          $(this).after('<span class="indicator"></span>');
        });

        $('strong>em, em>strong').each(function () {
          var text_len = $(this).text();
          if ($.trim(text_len).length==1) {
            $(this).parent('em, strong').addClass('cap-letter');
          }

        });

        $('.share-wrap .toggle-share').click(function () {
         $(this).next('.share-icons').slideToggle('fast');
         return false;
        });

        setTimeout(function(){
          $('[data-toggle="popover"]').popover();
        }, 250);

        $('.nav-mobile-toggle, .closebtn, .nav-mobile-overlay').click(function () {
            $(".app-wrapper").toggleClass('open');
        });

        //Single product scripts
        setTimeout(function(){
          var stock_len = $('.summary.entry-summary').find('p.stock').length;
          var stock_hght = $('.summary.entry-summary').find('p.stock').outerHeight();

          if (stock_len > 0) {
            $('.summary.entry-summary').addClass('top-padding');
            $('.summary.entry-summary').removeClass('pt-0');
            $('.summary.entry-summary').css('padding-top', stock_hght+4);
          }else{
            $('.summary.entry-summary').addClass('pt-0');
            $('.summary.entry-summary').removeClass('top-padding');
          }

          $('.availability-more-info').on('click', function (e) {
            return false;
          });


        }, 150);

        $( ".variations select" ).change(function() {
          setTimeout(function(){
          var stock_len = $('.summary.entry-summary').find('p.stock').length;
          var stock_hght = $('.summary.entry-summary').find('p.stock').outerHeight();

          if (stock_len > 0) {
            $('.summary.entry-summary').addClass('top-padding');
            $('.summary.entry-summary').removeClass('pt-0');
            $('.summary.entry-summary').css('padding-top', stock_hght+4);
          }else{
            $('.summary.entry-summary').addClass('pt-0');
            $('.summary.entry-summary').removeClass('top-padding');
          }

          $('.availability-more-info').popover('update');

        }, 150);
        });
        //Single product scripts



      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'page_template_template_repairs': {
      init: function() {
        // JavaScript to be fired on the about us page
          $('.gallery').each(function() { // the containers for all your galleries
              $(this).magnificPopup({
                  delegate: 'a', // the selector for gallery item
                  type: 'image',
                  gallery: {
                      enabled:true
                  }
              });
          });
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
